/**@jsx jsx */
import { css, jsx } from '@emotion/core';
import ContactInfo from './ContactInfo';

const AboutUs = () => {

    const aboutPage = css`
    direction: rtl;
    font-family: Segoe UI;
    display: flex;
    justify-content: center;
    `;

    const imgStyle = css`
    position: relative;
    width: 100%;
    height: fit-content;
    @media only screen and (max-width: 1080px) {
        display: none;
    }
    `;

    const cardStyle = css`
    padding-top: 15px;
    border-radius: 15px;
    position: absolute;
    background: white;
    min-width: 65%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 10px;
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
    @media only screen and (max-width: 1080px) {
        box-shadow: 0 0 black;
    }
    `;

    const textContainer = css`
    text-align: center;
    `;

    const titleStyle = css`
    font-size: 155%;
    font-weight: bold;
    `;

    const headerFirstLineStyle = css`
    display: contents;
    @media only screen and (max-width: 1080px) {
        display: none;
    }
    `;

    const headerLineStyle = css`
    display: none;
    @media only screen and (max-width: 1080px) {
        display: block;
    }
    `;

    const rowStyle = css`
    margin-top: 0.5%;
    font-size: 100%;
    `;

    const listStyle = css`
    list-style-type: circle;
    text-align: initial;
    @media only screen and (max-width: 1080px) {
        margin-right: 5%;
    }
    `;

    const gridContainer = css`
    display: grid;
    grid-template-columns: 20% 20% 20% 20% 20%;
    padding: 20px;
    grid-template-rows: 65px;
    grid-auto-rows: 65px;
    grid-gap: 5px;
    justify-content: center;
    @media only screen and (max-width: 1080px) {
        grid-template-columns: 35% 35% 35% 35%;
    }
    @media only screen and (max-width: 840px) {
        grid-template-columns: 35% 35% 35%;
    }
    @media only screen and (max-width: 635px) {
        grid-template-columns: 35% 35%;
    }
    `;

    const gridItem = css`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #6f787454;
    height: 100%;
    font-size: 20px;
    border-radius: 10px;
    :hover 
    {
        background-color: #4d86d7;
        color: white;
        font-weight: bold;
        transition: 0.2s;
    }
    `;

    const gridContactContainer = css`
    display: grid;
    grid-template-columns: 52% 52%;
    padding: 2%;
    grid-template-rows: 52%;
    grid-auto-rows: 52%;
    grid-gap: 7%;
    justify-content: center;
    margin-bottom: 3%;
    `;

    return (
        <div css={aboutPage}>
            <img css={imgStyle} alt={''} src={ require('../pictures/bg.jpg') } />
            <div css={cardStyle}>
                <div css={textContainer}>
                    <div css={titleStyle}>
                        <span>
                        "סנטורי"
                        </span>
                        <span css={headerFirstLineStyle}> שירותי הקלטה ותמלול מקצועיים</span> 
                        <span css={headerLineStyle}> שירותי הקלטה ותמלול מקצועיים</span>
                        </div>
                    <div css={rowStyle}>
                        מתמחים בשרותים מתקדמים  בתחום ההקלטה והתמלול.
                        </div>
                    <div css={rowStyle}>
                        טכנאי סאונד מקצועיים, ייצוגיים ומוכשרים.
                        </div>
                    <div css={rowStyle}>
                        ציוד מובחר ואיכותי הכולל מערכות גיבוי אוטומטיות.
                        </div>
                    <ul css={listStyle}>
                        <li>
                            מגיעים זמן ארוך לפני תחילת הישיבה.
                            </li>
                        <li>
                            מתמקמים בחדר הישיבות במקצועיות וביעילות.
                            </li>
                        <li>
                            מבצעים בדיקות הכרחיות לאיכות ההקלטה.
                            </li>
                        <li>
                            מגבים את ההקלטה בזמן אמת למניעת כשלים אפשריים.
                            </li>
                        <li>
                            אנשי צוות מנוסים ומקצועיים.
                            </li>
                        <li>
                            נסיון עשיר ומגוון בהקלטה בלבד או הקלטה ותמלול של:
                            </li>
                    </ul>
                    <div css={gridContainer}>
                        <div css={gridItem}>
                            ישיבות מועצת עיר
                            </div>
                        <div css={gridItem}>
                            בוררויות
                            </div>
                        <div css={gridItem}>
                            ישיבות בתי משפט
                            </div>
                        <div css={gridItem}>
                            ועדות ערר
                            </div>
                        <div css={gridItem}>
                            ועדות תכנון ובנייה עירוניות
                            </div>
                        <div css={gridItem}>
                            מכרזים (כח אדם)
                            </div>
                        <div css={gridItem}>
                            ועדות מכרזים
                            </div>
                        <div css={gridItem}>
                            ועדות ביקורת
                            </div>
                        <div css={gridItem}>
                            ועדות כספים
                            </div>
                        <div css={gridItem}>
                            ישיבות שימוע
                            </div>
                    </div>
                </div>
                <ContactInfo cssContactInfo={gridContactContainer}/>
            </div>
        </div>
    );
}

export default AboutUs;
